import { render, staticRenderFns } from "./SelosEOSCancelados.vue?vue&type=template&id=37502d0d&"
import script from "./SelosEOSCancelados.vue?vue&type=script&lang=js&"
export * from "./SelosEOSCancelados.vue?vue&type=script&lang=js&"
import style0 from "./SelosEOSCancelados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports